import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { RefreshCw, DoorOpen, DoorClosed } from "lucide-react";

export default function AccessLogs() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");

  const load = useCallback(() => {
    api.get(`/access-logs?limit=200&access=${filter}`).then((r) => setLogs(r.data));
  }, [filter]);
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [load]);

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div><p className="overline text-[#00f0ff]">Registro en vivo</p><h1 className="font-display text-5xl">ACCESOS</h1></div>
        <button data-testid="logs-refresh" onClick={load} className="flex items-center gap-2 border border-white/20 px-4 py-2.5 text-sm hover:bg-white/5">
          <RefreshCw className="w-4 h-4" /> Actualizar
        </button>
      </div>

      <div className="flex gap-2 mb-4">
        {[["", "Todos"], ["granted", "Permitidos"], ["denied", "Negados"]].map(([v, l]) => (
          <button key={v} data-testid={`log-filter-${v || "all"}`} onClick={() => setFilter(v)}
            className={`px-4 py-2.5 text-sm border ${filter === v ? "border-[#00f0ff] text-[#00f0ff]" : "border-white/10 text-white/50 hover:text-white"}`}>{l}</button>
        ))}
      </div>

      <div className="bg-[#0a0a0a] border border-white/10 overflow-x-auto">
        <table className="w-full text-sm" data-testid="logs-table">
          <thead><tr className="text-left overline border-b border-white/10">
            <th className="px-4 py-4">Socio</th><th className="px-4 py-4">Dirección</th><th className="px-4 py-4">Método</th>
            <th className="px-4 py-4">Motivo</th><th className="px-4 py-4">Hora</th><th className="px-4 py-4">Acceso</th>
          </tr></thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan="6" className="px-4 py-10 text-center text-white/30">Sin registros de acceso.</td></tr>}
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-white/5 hover:bg-white/5">
                <td className="px-4 py-3 font-semibold">{l.member_name}</td>
                <td className="px-4 py-3">
                  <span className="flex items-center gap-1.5 text-white/60">
                    {l.direction === "out" ? <DoorClosed className="w-4 h-4" /> : <DoorOpen className="w-4 h-4" />}
                    {l.direction === "out" ? "Salida" : "Entrada"}
                  </span>
                </td>
                <td className="px-4 py-3 capitalize text-white/50">{l.method}</td>
                <td className="px-4 py-3 text-white/50 text-xs">{l.reason}</td>
                <td className="px-4 py-3 font-mono-logs text-xs">{new Date(l.timestamp).toLocaleString()}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-1 text-xs font-bold uppercase border ${l.access === "granted" ? "text-[#39FF14] border-[#39FF14]/30 bg-[#39FF14]/10" : "text-[#FF3B30] border-[#FF3B30]/30 bg-[#FF3B30]/10"}`}>
                    {l.access === "granted" ? "Permitido" : "Negado"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
